















import { defineComponent, computed, useContext } from "@nuxtjs/composition-api";
import { useImage } from "@wemade-vsf/composables";

const swatchTypes = {
  ColorSwatchData: "color",
  ImageSwatchData: "image",
  TextSwatchData: "text",
};
export default defineComponent({
  name: "Swatch",
  props: {
    label: {
      type: String,
      default: "",
    },
    selected: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: "ColorSwatchData",
    },
    value: {
      type: String,
      default: "",
    },
    uid: {
      type: String,
      default: "",
    },
  },
  setup(props, { emit }) {
    const { app } = useContext();
    const { getMagentoImage } = useImage();
    const swatchType = computed(() =>
      swatchTypes[props.type] ? swatchTypes[props.type] : "color"
    );
    const style = computed(() => {
      switch (swatchType.value) {
        case "color":
          return { background: props.value };
        case "image":
          const { magentoBaseUrl } = app.$vsf.$magento.config;
          const fullUrl = `${magentoBaseUrl}/media/attribute/swatch${props.value}`;
          return {
            background: `url('${app.$img(getMagentoImage(fullUrl), {
              width: 200,
              height: 200,
            })}')`,
          };
        default:
          return {};
      }
    });

    const toggleSelection = () => {
      emit("change", props.selected ? "" : props.uid);
    };
    return {
      style,
      toggleSelection,
      swatchType,
    };
  },
});
